import ShiftSimulation, { getYesterdayDateISO } from "./shiftSimulation"
import { getCurrentSchedule, confirmSchedule, batchUpdateSchedule, getSchedule, getUserSchedule } from "./scheduleSimulation"
import { getStoreQr, getStoresWithinTheGroup, getUsersWithinTheStore, getArchivedUsersOfTheStore, getQrCodeOfTheStore, getBranchInfo } from './storeSimulation'
import { checkBreaklistByBatch, getBreaklistForCutoff, getBreaklistInfo, getGeneratedBreaklists, getGenereatedBreaklistInfo, getPendingBreaklist } from './breaklistSimulation'
import { getRequiredDocuments, uploadedDocuments, getDocumentsStatusOfEmployees, editDocument } from "./documentsSimulation"
import { getThemeSong, getCoc, getEmployeeHandbook, getMissionAndVision } from "./myCompanySimulation"
import { getFlows, getRequestsForFlow, getRequestLogs } from "./myRequestsSimulation"
import { getAnnouncements } from './announcementsSimulation'
import { logAction } from "./logsSimulation"
import { getReportsForExport, getRecordsV3 } from "./reportsSimulation"
import { getTimeAdjustmentLogs } from './timeAdjustmentSimulation'
import { getBroadcastHistory, sendBroadcast } from './broadcastSimulation'
import { getTrainingMaterials, createTrainingMaterial } from "./trainingMaterialsSimulation"
import { getPayslipCutoffs } from "./payslipSimulation"
import DemoState from 'components/demo/DemoState'

export const appVersionResponse = [
    {
        url: 'config/native-app-version',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: {
                    "data": {
                        "minVersionPwa": "4.13.35",
                        "minVersionAndroid": "1.0.32",
                        "minVersionIos": "1.0.35",
                        "minVersion": "4.13.35",
                        "storeUrlAndroid": "https://play.google.com/store/apps/details?id=com.sparkle.stkmobile",
                        "storeUrlIos": "https://apps.apple.com/ph/app/sparkle-time-keeping/id6670240193",
                        "latestVersionChange": {
                            "type": "increase",
                            "features": [
                                "demo: Allow users to be able to demo some of the STK's functionality."
                            ],
                            "reason": ""
                        }
                    },
                    "error": null,
                    "meta": {}
                },
                sequences: [],
            }]
        }]
    },

]



export const loginResponses = [
    {
        url: 'login/new',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => {
                    let demoState = DemoState.status()
                    let userData = {
                        "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYxNDQyYTE3YTY1NjZhMDAxNjIzYmYyMCIsImlhdCI6MTc3NzUxMDg2N30.mGHxYSNpXD3mrRzfW_G_UFJrZfBJZkEl-U7hJEekOnM",
                        "_id": "61442a17a6566a001623bf20",
                        "googleId": null,
                        "displayName": "Sparkle Demo",
                        "firstName": "Sparkle Demo",
                        "lastName": "Pareja",
                        "image": null,
                        "company": "Sparkle Star International - Inhouse",
                        "position": "Sparkle Demo user",
                        "email": "sparkledemo@gmail.com",
                        "phone": "+639123123123",
                        "verificationCode": null,
                        "hashed_password": "5d093934445de78c23b500251966258af3252599",
                        "resetToken": "435729",
                        "role": 0,
                        "isVerified": true,
                        "isOnBoarded": true,
                        "createdAt": "2021-09-17T05:39:34.523Z",
                        "updatedAt": "2026-04-20T03:25:42.479Z",
                        "__v": 2,
                        "salt": "707cf070-3005-11ee-ac6a-a30ff2293093",
                        "isArchived": false,
                        "uiVersion": "old",
                        "alternativeBreaklistEmail": "",
                        "archiveRemarks": "",
                        "changeMpinOtp": "",
                        "currentAddress": "",
                        "emergencyContactNumber": "",
                        "emergencyContactPerson": "",
                        "emergencyContactRelationship": "",
                        "isTimeAdjustmentVerified": false,
                        "mobileChangeOtp": "",
                        "mpin": "",
                        "newEmailOtp": "",
                        "oldEmailOtp": "",
                        "pagIbigNumber": "",
                        "philHealthNumber": "",
                        "readBroadcasts": [
                            "69c1cdfc7856260057a3e5b8",
                            "69d2f263652ec60058ed6b1b"
                        ],
                        "scheduleCostOtp": "",
                        "sssNumber": "",
                        "timeInQROTP": "",
                        "tinNumber": "",
                        "useAlternativeBreaklistEmail": false,
                        "store_id": "61442a17a6566a001623bf20",
                        "survey_done": true
                    }

                    console.log('demo state is', demoState)
                    if (!demoState || !demoState.status) {
                        return userData
                    }

                    if (demoState.status && demoState.user === 'employee') {
                        return userData
                    }

                    if (demoState.status && demoState.user === 'store') {
                        userData.role = 1

                        return userData
                    }
                },

                /*
                data: {
                    "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYxNDQyYTE3YTY1NjZhMDAxNjIzYmYyMCIsImlhdCI6MTc3NjY1NTU0MiwiZXhwIjoxNzc2OTE0NzQyfQ.T4LHtRXQE80YbV5On74nscfB3mkZtqmFnNNdNcjfOtI",
                    "_id": "61442a17a6566a001623bf20",
                    "googleId": null,
                    "displayName": "Sparkle Demo",
                    "firstName": "Sparkle",
                    "lastName": "Demo",
                    "image": null,
                    "company": "Sparkle Star International - Inhouse",
                    "position": "Sparkle Demo",
                    "email": "sparkledemo@gmail.com",
                    "phone": "+639123123123",
                    "verificationCode": null,
                    "resetToken": "435729",
                    "role": 0,
                    "isVerified": true,
                    "isOnBoarded": true,
                    "createdAt": "2021-09-17T05:39:34.523Z",
                    "updatedAt": "2026-04-19T23:06:39.617Z",
                    "__v": 2,
                    "isArchived": false,
                    "uiVersion": "old",
                    "alternativeBreaklistEmail": "",
                    "archiveRemarks": "",
                    "changeMpinOtp": "",
                    "currentAddress": "",
                    "emergencyContactNumber": "",
                    "emergencyContactPerson": "",
                    "emergencyContactRelationship": "",
                    "isTimeAdjustmentVerified": false,
                    "mobileChangeOtp": "",
                    "mpin": "",
                    "newEmailOtp": "",
                    "oldEmailOtp": "",
                    "pagIbigNumber": "",
                    "philHealthNumber": "",
                    "readBroadcasts": [
                        "69c1cdfc7856260057a3e5b8",
                        "69d2f263652ec60058ed6b1b"
                    ],
                    "scheduleCostOtp": "",
                    "sssNumber": "",
                    "timeInQROTP": "",
                    "tinNumber": "",
                    "useAlternativeBreaklistEmail": false,
                    "store_id": "61442a17a6566a001623bf20"
                },*/
                sequences: []
            }]
        }],
    },

    {

        url: 'phone/check',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: { "success": false, "msg": "MPIN not yet set" },
                sequences: []
            }]
        }],
    }
]


export const userDataResponses = [
    {
        url: 'user/61442a17a6566a001623bf20',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => {
                    console.log('user data response')
                    let demoState = DemoState.status()
                    let userData = {
                        "_id": "61442a17a6566a001623bf20",
                        "googleId": null,
                        "displayName": "Sparkle Demo",
                        "firstName": "Sparkle Demo",
                        "lastName": "Pareja",
                        "image": null,
                        "company": "Sparkle Star International - Inhouse",
                        "position": "Sparkle Demo user",
                        "email": "sparkledemo@gmail.com",
                        "phone": "+639123123123",
                        "verificationCode": null,
                        "hashed_password": "5d093934445de78c23b500251966258af3252599",
                        "resetToken": "435729",
                        "role": 0,
                        "isVerified": true,
                        "isOnBoarded": true,
                        "createdAt": "2021-09-17T05:39:34.523Z",
                        "updatedAt": "2026-04-20T03:25:42.479Z",
                        "__v": 2,
                        "salt": "707cf070-3005-11ee-ac6a-a30ff2293093",
                        "isArchived": false,
                        "uiVersion": "old",
                        "alternativeBreaklistEmail": "",
                        "archiveRemarks": "",
                        "changeMpinOtp": "",
                        "currentAddress": "",
                        "emergencyContactNumber": "",
                        "emergencyContactPerson": "",
                        "emergencyContactRelationship": "",
                        "isTimeAdjustmentVerified": false,
                        "mobileChangeOtp": "",
                        "mpin": "",
                        "newEmailOtp": "",
                        "oldEmailOtp": "",
                        "pagIbigNumber": "",
                        "philHealthNumber": "",
                        "readBroadcasts": [
                            "69c1cdfc7856260057a3e5b8",
                            "69d2f263652ec60058ed6b1b"
                        ],
                        "scheduleCostOtp": "",
                        "sssNumber": "",
                        "timeInQROTP": "",
                        "tinNumber": "",
                        "useAlternativeBreaklistEmail": false,
                        "store_id": "61442a17a6566a001623bf20",
                        "survey_done": true
                    }

                    if (!demoState || !demoState.status) {
                        return userData
                    }

                    if (demoState.status && demoState.user === 'employee') {
                        return userData
                    }

                    if (demoState.status && demoState.user === 'store') {
                        userData.role = 1

                        return userData
                    }
                },
                sequences: []
            }],
        },]
    },
    {
        url: 'edit/profile/61442a17a6566a001623bf20',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => {
                    return {
                        success: true,
                        msg: "User profile updated"
                    }
                }
            }]
        }]
    }
]

export const userBroadcastsResponses = [
    {
        url: 'broadcast/user',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: {
                    "success": true,
                    "data": [
                        {
                            "_id": "69e566a62dd4a00057e8382f",
                            "title": "Sparkling morning daw 🌟 hehehehe",
                            "message": "Small wins today lead to big success. Start by timing in ⏱️",
                            "sentAt": "2026-04-19T23:35:02.490Z",
                            "createdAt": "2026-04-19T23:35:02.493Z",
                            "read": false
                        },
                        {
                            "_id": "69e20864e2ad0a00572806d3",
                            "title": "Salary In 📣",
                            "message": "Oh mag tipid ka. Magastos ka pa naman. 😅",
                            "sentAt": "2026-04-17T10:16:04.914Z",
                            "createdAt": "2026-04-17T10:16:04.916Z",
                            "read": false
                        },
                        {
                            "_id": "69ded2b1ca1a0600579ec9c0",
                            "title": "🚀 Productivity Boost",
                            "message": "Clock in, focus up, and let Sparkle track your success 💼✨",
                            "sentAt": "2026-04-14T23:50:09.809Z",
                            "createdAt": "2026-04-14T23:50:09.814Z",
                            "read": false
                        },
                        {
                            "_id": "69dd7f5e6e00670057c76058",
                            "title": "⏰ Start Strong",
                            "message": "New day, new goals! Don’t forget to Time In and shine today ✨",
                            "sentAt": "2026-04-13T23:42:22.559Z",
                            "createdAt": "2026-04-13T23:42:22.564Z",
                            "read": false
                        },
                        {
                            "_id": "69d6f6e0185da200561c23fa",
                            "title": "🇵🇭 𝐀𝐫𝐚𝐰 𝐧𝐠 𝐊𝐚𝐠𝐢𝐭𝐢𝐧𝐠𝐚𝐧",
                            "message": "Tapang noon, disiplina ngayon. 💙❤️💛\n\nPara sa mga modern-day heroes na on time, on grind—salute! 🫡",
                            "sentAt": "2026-04-09T00:46:24.889Z",
                            "createdAt": "2026-04-09T00:46:24.892Z",
                            "read": false
                        },
                    ],
                    "count": 5
                }
            }]
        }]
    },
]


export const recordsResponses = [
    {
        url: 'user/limited/recordsV4',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: [
                    {
                        "_id": "69e55fff7b564a00699d7993",
                        "record": [
                            {
                                "dateTime": "2026-04-20T07:06:39.539Z",
                                "status": "time-in",
                                "month": 4,
                                "day": 20,
                                "year": 2026,
                                "time": 1776639999583,
                                "date": "2026-04-20T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.8779002,
                                    "longitude": 121.0476598
                                },
                                "address": "N/A",
                                "ip": "Test"
                            }
                        ],
                        "uid": "61442a17a6566a001623bf20",
                        "date": "2026-04-20T00:00:00.000Z",
                        "status": "time-in",
                        "createdAt": "2026-04-20T07:06:39.539Z",
                        "updatedAt": "2026-04-20T07:06:39.539Z",
                        "__v": 0,
                        "position": "Developer",
                        "startShift": "08:00",
                        "endShift": "05:00",
                        "breakMinutes": 60,
                        "lateMinutes": 0,
                        "hoursWorked": 0,
                        "overtime": 0,
                        "nightShift": 0,
                        "isRestDay": 0,
                        "holidayHours": "0"
                    },
                    {
                        "_id": "69e170fb7b564a006967dcd4",
                        "record": [
                            {
                                "dateTime": "2026-04-17T07:30:02.795Z",
                                "status": "time-in",
                                "month": 4,
                                "day": 17,
                                "year": 2026,
                                "time": 1776382202832,
                                "date": "2026-04-17T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.8778848,
                                    "longitude": 121.0476869
                                },
                                "address": "N/A",
                                "ip": "Test"
                            },
                            {
                                "dateTime": "2026-04-17T17:02:55.453Z",
                                "status": "time-out",
                                "month": 4,
                                "day": 17,
                                "year": 2026,
                                "time": 1776416575490,
                                "date": "2026-04-17T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.877734128125777,
                                    "longitude": 121.04746142905557
                                },
                                "address": "N/A",
                                "ip": "Test"
                            }
                        ],
                        "uid": "61442a17a6566a001623bf20",
                        "date": "2026-04-17T00:00:00.000Z",
                        "status": "time-out",
                        "createdAt": "2026-04-17T07:30:02.795Z",
                        "updatedAt": "2026-04-17T09:02:55.937Z",
                        "__v": 0,
                        "position": "Developer",
                        "startShift": "08:00",
                        "endShift": "05:00",
                        "breakMinutes": 60,
                        "lateMinutes": 0,
                        "hoursWorked": 8,
                        "overtime": 0,
                        "nightShift": 0,
                        "isRestDay": 0,
                        "holidayHours": "0"
                    },
                    {
                        "_id": "69e018407b564a006952c69d",
                        "record": [
                            {
                                "dateTime": "2026-04-16T06:59:12.296Z",
                                "status": "time-in",
                                "month": 4,
                                "day": 16,
                                "year": 2026,
                                "time": 1776293952335,
                                "date": "2026-04-16T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.877826981851541,
                                    "longitude": 121.04753088314834
                                },
                                "address": "N/A",
                                "ip": "Test"
                            },
                            {
                                "dateTime": "2026-04-16T17:23:44.352Z",
                                "status": "time-out",
                                "month": 4,
                                "day": 16,
                                "year": 2026,
                                "time": 1776331424385,
                                "date": "2026-04-16T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.877775056592656,
                                    "longitude": 121.0474834803567
                                },
                                "address": "N/A",
                                "ip": "Test"
                            }
                        ],
                        "uid": "61442a17a6566a001623bf20",
                        "date": "2026-04-16T00:00:00.000Z",
                        "status": "time-out",
                        "createdAt": "2026-04-16T06:59:12.296Z",
                        "updatedAt": "2026-04-16T09:23:44.804Z",
                        "__v": 0,
                        "position": "Developer",
                        "startShift": "08:00",
                        "endShift": "05:00",
                        "breakMinutes": 60,
                        "lateMinutes": 0,
                        "hoursWorked": 8,
                        "overtime": 0,
                        "nightShift": 0,
                        "isRestDay": 0,
                        "holidayHours": "0"
                    },
                    {
                        "_id": "69decf0f557af9006d5a24f7",
                        "record": [
                            {
                                "dateTime": "2026-04-15T07:34:39.019Z",
                                "status": "time-in",
                                "month": 4,
                                "day": 15,
                                "year": 2026,
                                "time": 1776209679051,
                                "date": "2026-04-15T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.8778457,
                                    "longitude": 121.0475873
                                },
                                "address": "N/A",
                                "ip": "Test"
                            },
                            {
                                "dateTime": "2026-04-15T17:41:37.353Z",
                                "status": "time-out",
                                "month": 4,
                                "day": 15,
                                "year": 2026,
                                "time": 1776246097387,
                                "date": "2026-04-15T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.877807702977643,
                                    "longitude": 121.04742784270347
                                },
                                "address": "N/A",
                                "ip": "Test"
                            }
                        ],
                        "uid": "61442a17a6566a001623bf20",
                        "date": "2026-04-15T00:00:00.000Z",
                        "status": "time-out",
                        "createdAt": "2026-04-15T07:34:39.019Z",
                        "updatedAt": "2026-04-15T09:41:37.756Z",
                        "__v": 0,
                        "position": "Developer",
                        "startShift": "08:00",
                        "endShift": "05:00",
                        "breakMinutes": 60,
                        "lateMinutes": 0,
                        "hoursWorked": 8,
                        "overtime": 0,
                        "nightShift": 0,
                        "isRestDay": 0,
                        "holidayHours": "0"
                    },
                    {
                        "_id": "69dd87a1d1376c0069ee69e6",
                        "record": [
                            {
                                "dateTime": "2026-04-14T08:17:36.938Z",
                                "status": "time-in",
                                "month": 4,
                                "day": 14,
                                "year": 2026,
                                "time": 1776125856976,
                                "date": "2026-04-14T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.603722811819846,
                                    "longitude": 120.98883561722515
                                },
                                "address": "N/A",
                                "ip": "Test"
                            },
                            {
                                "dateTime": "2026-04-14T18:39:13.555Z",
                                "status": "time-out",
                                "month": 4,
                                "day": 14,
                                "year": 2026,
                                "time": 1776163153590,
                                "date": "2026-04-14T00:00:00.000Z",
                                "location": {
                                    "latitude": 14.6036592,
                                    "longitude": 120.9890098
                                },
                                "address": "N/A",
                                "ip": "Test"
                            }
                        ],
                        "uid": "61442a17a6566a001623bf20",
                        "date": "2026-04-14T00:00:00.000Z",
                        "status": "time-out",
                        "createdAt": "2026-04-14T08:17:36.938Z",
                        "updatedAt": "2026-04-14T10:39:13.936Z",
                        "__v": 0,
                        "position": "Developer",
                        "startShift": "08:00",
                        "endShift": "05:00",
                        "breakMinutes": 60,
                        "lateMinutes": 17,
                        "hoursWorked": 9,
                        "overtime": 0,
                        "nightShift": 0,
                        "isRestDay": 0,
                        "holidayHours": "9"
                    }
                ],
                sequences: []
            }]
        }]
    },
    {
        url: 'user/limited/records/61442a17a6566a001623bf20',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => {
                    let record = ShiftSimulation.getTimeRecordByStatus()
                    return [
                        ...record,
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-17T07:30:02.795Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 17,
                                    "year": 2026,
                                    "time": 1776382202832,
                                    "date": "2026-04-17T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.8778848,
                                        "longitude": 121.0476869
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-17T17:02:55.453Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 17,
                                    "year": 2026,
                                    "time": 1776416575490,
                                    "date": "2026-04-17T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.877734128125777,
                                        "longitude": 121.04746142905557
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69e170fb7b564a006967dcd4",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-17T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-17T07:30:02.795Z",
                            "updatedAt": "2026-04-17T09:02:55.937Z",
                            "__v": 0
                        },
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-16T06:59:12.296Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 16,
                                    "year": 2026,
                                    "time": 1776293952335,
                                    "date": "2026-04-16T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.877826981851541,
                                        "longitude": 121.04753088314834
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-16T17:23:44.352Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 16,
                                    "year": 2026,
                                    "time": 1776331424385,
                                    "date": "2026-04-16T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.877775056592656,
                                        "longitude": 121.0474834803567
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69e018407b564a006952c69d",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-16T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-16T06:59:12.296Z",
                            "updatedAt": "2026-04-16T09:23:44.804Z",
                            "__v": 0
                        },
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-15T07:34:39.019Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 15,
                                    "year": 2026,
                                    "time": 1776209679051,
                                    "date": "2026-04-15T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.8778457,
                                        "longitude": 121.0475873
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-15T17:41:37.353Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 15,
                                    "year": 2026,
                                    "time": 1776246097387,
                                    "date": "2026-04-15T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.877807702977643,
                                        "longitude": 121.04742784270347
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69decf0f557af9006d5a24f7",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-15T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-15T07:34:39.019Z",
                            "updatedAt": "2026-04-15T09:41:37.756Z",
                            "__v": 0
                        },
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-14T08:17:36.938Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 14,
                                    "year": 2026,
                                    "time": 1776125856976,
                                    "date": "2026-04-14T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.603722811819846,
                                        "longitude": 120.98883561722515
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-14T18:39:13.555Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 14,
                                    "year": 2026,
                                    "time": 1776163153590,
                                    "date": "2026-04-14T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.6036592,
                                        "longitude": 120.9890098
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69dd87a1d1376c0069ee69e6",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-14T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-14T08:17:36.938Z",
                            "updatedAt": "2026-04-14T10:39:13.936Z",
                            "__v": 0
                        },
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-13T08:01:12.037Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 13,
                                    "year": 2026,
                                    "time": 1776038472078,
                                    "date": "2026-04-13T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.60372173361471,
                                        "longitude": 120.9888025646543
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-13T08:32:04.055Z",
                                    "status": "break-in",
                                    "month": 4,
                                    "day": 13,
                                    "year": 2026,
                                    "time": 1776040324090,
                                    "date": "2026-04-13T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.603671717097045,
                                        "longitude": 120.98887237927879
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-13T08:37:22.356Z",
                                    "status": "break-out",
                                    "month": 4,
                                    "day": 13,
                                    "year": 2026,
                                    "time": 1776040642390,
                                    "date": "2026-04-13T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.60371630119469,
                                        "longitude": 120.98880538925292
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-13T11:44:47.758Z",
                                    "status": "break-in",
                                    "month": 4,
                                    "day": 13,
                                    "year": 2026,
                                    "time": 1776051887859,
                                    "date": "2026-04-13T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.603607833077996,
                                        "longitude": 120.98889318381791
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-13T11:45:14.313Z",
                                    "status": "break-out",
                                    "month": 4,
                                    "day": 13,
                                    "year": 2026,
                                    "time": 1776051914443,
                                    "date": "2026-04-13T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.603622588702414,
                                        "longitude": 120.9887678506257
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-13T17:01:30.587Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 13,
                                    "year": 2026,
                                    "time": 1776070890624,
                                    "date": "2026-04-13T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.603688236990422,
                                        "longitude": 120.98885357922207
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69dc32487612fa0057e9af8b",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-13T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-13T08:01:12.037Z",
                            "updatedAt": "2026-04-13T09:01:31.049Z",
                            "__v": 0
                        },
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-10T08:17:55.551Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 10,
                                    "year": 2026,
                                    "time": 1775780275591,
                                    "date": "2026-04-10T00:00:00.000Z",
                                    "location": {
                                        "latitude": 10.7824764,
                                        "longitude": 106.692754
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-10T19:37:40.632Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 10,
                                    "year": 2026,
                                    "time": 1775821060666,
                                    "date": "2026-04-10T00:00:00.000Z",
                                    "location": {
                                        "latitude": 10.7833007,
                                        "longitude": 106.692766
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69d841b37612fa0057afed42",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-10T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-10T08:17:55.551Z",
                            "updatedAt": "2026-04-10T11:37:41.030Z",
                            "__v": 0
                        },
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-08T07:43:10.973Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 8,
                                    "year": 2026,
                                    "time": 1775605391006,
                                    "date": "2026-04-08T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.6598149,
                                        "longitude": 120.9999993
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-08T17:15:53.404Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 8,
                                    "year": 2026,
                                    "time": 1775639753438,
                                    "date": "2026-04-08T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.5199658,
                                        "longitude": 121.0137732
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69d5968f2dbf6a00689ba25e",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-08T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-08T07:43:10.973Z",
                            "updatedAt": "2026-04-08T09:15:53.888Z",
                            "__v": 0
                        },
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-07T07:48:21.316Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 7,
                                    "year": 2026,
                                    "time": 1775519301353,
                                    "date": "2026-04-07T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.6395223,
                                        "longitude": 120.9921809
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-07T17:39:03.202Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 7,
                                    "year": 2026,
                                    "time": 1775554743241,
                                    "date": "2026-04-07T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.6037893,
                                        "longitude": 120.9888751
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69d4464519b0a00068ec2971",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-07T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-07T07:48:21.316Z",
                            "updatedAt": "2026-04-07T09:39:03.583Z",
                            "__v": 0
                        },
                        {
                            "record": [
                                {
                                    "dateTime": "2026-04-06T07:22:30.685Z",
                                    "status": "time-in",
                                    "month": 4,
                                    "day": 6,
                                    "year": 2026,
                                    "time": 1775431350719,
                                    "date": "2026-04-06T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.877875476791791,
                                        "longitude": 121.0475424124047
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                },
                                {
                                    "dateTime": "2026-04-06T18:44:29.821Z",
                                    "status": "time-out",
                                    "month": 4,
                                    "day": 6,
                                    "year": 2026,
                                    "time": 1775472269856,
                                    "date": "2026-04-06T00:00:00.000Z",
                                    "location": {
                                        "latitude": 14.8778324,
                                        "longitude": 121.0476488
                                    },
                                    "address": "N/A",
                                    "ip": "Test"
                                }
                            ],
                            "_id": "69d2eeb7f941a00069340b30",
                            "uid": "61442a17a6566a001623bf20",
                            "date": "2026-04-06T00:00:00.000Z",
                            "status": "time-out",
                            "createdAt": "2026-04-06T07:22:30.685Z",
                            "updatedAt": "2026-04-06T10:44:30.245Z",
                            "__v": 0
                        }]
                },
                sequences: []
            }]
        }]
    },
    {
        url: 'user/limited/recordsV3',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getRecordsV3()
            }]
        }]
    }
];



export const announcementsResponses = [
    {
        url: 'user/limited/announcements',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: {
                    "success": true,
                    "data": [
                        {
                            "_id": "68633590c5e2f7008751b8fb",
                            "uid": "6720a49bed59cc0095f81d13",
                            "store": "Sparkle Star International - Inhouse",
                            "title": "You Wish, We Code!",
                            "link": "https://feat-dynamic-form.sapex-frontend.pages.dev/form/6861d834207281b773d1f08c",
                            "createdAt": "2025-07-01T09:10:40.012Z",
                            "img": "https://prod-timein.s3.ap-southeast-1.amazonaws.com/1751331877798.png",
                            "updatedAt": "2025-10-29T11:51:15.390Z",
                            "__v": 0,
                            "rank": 3,
                            "toggle": true
                        },
                    ]
                },
                sequences: []
            }]
        }],
        url: 'announcements',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getAnnouncements()
            }]
        }]
    }
];


//this should update the time in status of the user, so that when we fetch the time in status of the user it will return the updated time in status
export const userTimeInStatus = [
    {
        url: 'user/status/61442a17a6566a001623bf20',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: (requestData) => {
                    console.log('shift simulation data time in stqatus', requestData)
                    let response = ShiftSimulation.getTimeRecordByStatus()

                    console.log('data is', response)
                    return response
                },
                sequences: [],

            }]
        }]
    },
];

export const diceGameResponses = [
    {
        url: 'dice-game/stats',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: { "success": true, "stats": { "totalGames": 0, "totalWinners": 0, "companyStats": [] } },
                sequences: []
            }]
        }]
    }
];

export const featuresResponses = [
    {
        url: 'check/feature',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: [
                    {
                        "success": true,
                        "features": [
                            { "feature": "My Schedule" },
                            { "feature": "Premium Values" },
                            { "feature": "My Company" },
                            { "feature": "Training And Development" },
                            { "feature": "My Documents" },
                            { "feature": "My Request" }
                        ]
                    }
                ],
                sequences: []
            }]
        }]
    }
];

export const scheduleResponses = [
    {
        url: 'v2/specific/schedule/with/date',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: (requestObj) => {
                    console.log('request obj for schedule is ', requestObj)
                    try {
                        let data = getCurrentSchedule(requestObj.date)
                        console.log('get current schedule ', data)
                        return data
                    } catch (err) {
                        console.error('Error in getting schedule:', err);
                    }
                },

                /*
                data: [
                    {
                        "_id": "69cbf44073ba07b34287286a",
                        "uid": "61442a17a6566a001623bf20",
                        "date": "2026-04-20T00:00:00.000Z",
                        "breakMin": 60,
                        "company": "Sparkle Star International - Inhouse",
                        "createdAt": "2026-03-31T16:20:16.485Z",
                        "from": "08:00",
                        "name": "Sparkle Demo",
                        "nightdiff": 0,
                        "otHours": 0,
                        "position": "Demo",
                        "restday": 0,
                        "to": "05:00",
                        "totalHours": "20",
                        "updatedAt": "2026-04-19T23:06:18.161Z",
                        "confirmed": true
                    }
                ],*/
                sequences: []
            }]
        }]
    },
    {
        url: 'specific/schedule/employee',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => {
                    let data = confirmSchedule()
                    return data
                }
            }]
        }]
    },
    {
        url: 'schedule/batch',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => batchUpdateSchedule()
            }]
        }]
    },
    {
        url: 'schedule/v2',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getSchedule()
            }]
        }]
    },
    {
        url: 'schedule/range',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getBreaklistInfo()
            }]
        }]
    },
    {
        url: 'list/breaklist',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getGeneratedBreaklists()
            }]
        }]
    },
    {
        url: 'v2/breaklistinfo',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getGenereatedBreaklistInfo()
            }]
        }]
    },
    {
        url: 'range/schedule',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getBreaklistInfo()
            }]
        }]
    },
    {
        url: 'schedule/61442a17a6566a001623bf20',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => getUserSchedule()
            }]
        }]
    }


];

export const checklistResponses = [{
    url: 'checklist',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: {
                "success": true,
                "data": [
                    {
                        "_id": "663986199c2935c89b5a237f",
                        "store": "Sparkle Star International - Inhouse",
                        "__v": 0,
                        "checklists": [
                            "I hereby declare that I am physically present upon signing in. Furthermore, I acknowledge that I have:",
                            "An appropriate attire and ID.",
                            "Planned to do list/Completed all the task",
                            "Review all GC's and provide feedback.",
                            "Organize workspace daily.       🌟Have a starry smile😊🌟"
                        ],
                        "createdAt": "2024-05-07T01:38:33.289Z",
                        "updatedAt": "2024-05-07T01:38:33.289Z"
                    }
                ]
            },
            sequences: []
        }]
    }]
}]


//updating time
export const userCurrentShiftResponses = [
    {
        url: 'user/time/61442a17a6566a001623bf20',
        ops: [
            {
                method: 'post',
                responses: [{
                    status: 200,
                    data: (requestBody) => {
                        let data = ShiftSimulation.updateTimeRecord(requestBody.status)
                        return data
                    },
                    sequences: [],

                    //side effect functions are done after response is return
                    sideEffect: () => {
                        console.log('break in side effect ')
                        ShiftSimulation.updateStatus('break-in')
                    }
                }
                ]
            },]
    }
]

export const storeResponses = [/*{
    url: 'store/qr/*',
    ops: [{
        method: 'get',
        responses: [{
            status: 200,
            data: () => getStoreQr()
        }]
    }]
},*/ {
        url: 'v2/group/store/61442a17a6566a001623bf20',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => getStoresWithinTheGroup()
            }]
        }],
    }, {
        url: 'store/users/61442a17a6566a001623bf20',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => getUsersWithinTheStore()
            }]
        }]
    }, {
        url: 'user/store',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => getUsersWithinTheStore()
            }]
        }]
    }, {
        url: 'store/users/archive/61442a17a6566a001623bf20',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => getArchivedUsersOfTheStore()
            }]
        }]
    }, {
        url: 'stores/time-in-qr/get',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getQrCodeOfTheStore()
            }]
        }]
    }, {
        url: 'store/branch/61442a17a6566a001623bf20',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => getBranchInfo()
            }]
        }]
    }]

export const otpResponses = [{
    url: 'v2/otp/verification',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: {
                success: true,
                message: 'Verified successfully with internal OTP'
            }
        }]
    }]
}]

export const breaklistResponses = [{
    url: 'check/breaklist',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: {
                success: true
            }
        }]
    }]
}, {
    url: 'check/breaklist/batch',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => checkBreaklistByBatch()
        }]
    }]
}, {
    url: 'v2/breaklist',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getBreaklistForCutoff()
        }]
    }]
}, {
    url: 'save/breaklist',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: {
                success: true,
                msg: "Breaklists Saved",
            }
        }]
    }]
}, {
    url: 'list/breaklist/pending',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getPendingBreaklist()
        }]
    }]
}]


export const logResponses = [{
    url: 'action-logs/create',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => logAction()
        }]
    }]
}]

export const documentsResponses = [
    {
        url: 'required-documents/list',
        ops: [{
            method: 'post',
            responses: [{
                status: 200,
                data: () => getRequiredDocuments()
            }]
        }]
    },

    {
        url: 'employee-documents/list',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => uploadedDocuments()
            }]
        }]
    },

    {
        url: 'required-documents/6810842055f7190073871f7f',
        ops: [{
            method: 'get',
            responses: [{
                status: 200,
                data: () => editDocument()
            }]
        }]
    }
]

export const myCompanyResponses = [{
    url: 'stores/theme-song/get',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getThemeSong()
        }]
    }]
},
{
    url: 'get/coc',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getCoc()
        }]
    }]
},
{
    url: 'stores/employee-handbook/get',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getEmployeeHandbook()
        }]
    }]
},
{
    url: 'stores/mission-vision/get',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getMissionAndVision()
        }]
    }]
}]

export const myRequestResponses = [{
    url: 'myrequest/process-flow/get',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getFlows()
        }]
    }]
}, {
    url: 'v2/myrequest/employee/process/flow_1773882928260_8ipjy8fu8/responses/bulk',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getRequestsForFlow()
        }]
    }]
}, {
    url: 'v2/myrequeststatus/69f1933f4fdcea00572136c8/logs',
    ops: [{
        method: 'get',
        responses: [{
            status: 200,
            data: () => getRequestLogs()
        }]
    }]
}, {
    url: 'employee-documents/bulk',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getDocumentsStatusOfEmployees()
        }]
    }]
}, {
    url: 'v2/myrequest/process/flow_1773882928260_8ipjy8fu8/responses/bulk',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getRequestsForFlow()
        }]
    }]
}]

export const reportsResponses = [{
    url: 'user/recordsv2/61442a17a6566a001623bf20/2026-05-03/2026-05-03',
    ops: [{
        method: 'get',
        responses: [{
            status: 200,
            data: () => getReportsForExport()
        }]
    }]
}]

export const timeAdjustmentResponses = [{
    url: 'time-adjustment-logs',
    ops: [{
        method: 'get',
        responses: [{
            status: 200,
            data: () => getTimeAdjustmentLogs()
        }]
    }]
}]

export const storeBroadcastResponses = [{
    url: 'broadcast/history',
    ops: [{
        method: 'get',
        responses: [{
            status: 200,
            data: () => getBroadcastHistory()
        }]
    }]
}, {
    url: 'broadcast/send',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => sendBroadcast()
        }]
    }]
}]

export const trainingMaterialsResponses = [{
    url: 'training-materials/get',
    ops: [{
        method: 'get',
        responses: [{
            status: 200,
            data: () => getTrainingMaterials()
        }]
    }]
}, {
    url: 'training-materials/create',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => createTrainingMaterial()
        }]
    }]
}]


export const payslipResponses = [{
    url: 'payslip-info',
    ops: [{
        method: 'post',
        responses: [{
            status: 200,
            data: () => getPayslipCutoffs()
        }]
    }]
}]